const c = (window as any).docsConfig;
export default {
  title: c.title,
  getMainUrl: c.getMainUrl,
  backgroundColor: c.backgroundColor,
  color: c.color,
  specs: c.specs,
  defaultSpecUrl: (c.specs.find(o => o.isDefault === true) || c.specs[0])?.value,
  invertHeaderColor: c.invertHeaderColor,
  logoBase64: c.logoBase64,
  appendSpecTitleInTitleArea: c.appendSpecTitleInTitleArea
};
